/*
 This file is part of GNU Taler
 (C) 2025 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU Affero Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU Affero Public License for more details.

 You should have received a copy of the GNU Affero Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import { TalerFormAttributes } from "@gnu-taler/taler-util";
import { InternationalizationAPI } from "../../context/translation.js";
import { FormMetadata, SingleColumnFormDesign } from "../forms-types.js";

export const form_challenger_email = (
  i18n: InternationalizationAPI,
): FormMetadata => ({
  label: i18n.str`Email verification`,
  description: i18n.str`Challenge email ownership.`,
  id: "challenger-email",
  version: 0,
  config: design_challenger_email(i18n),
});

/**
 * Design of the challenger email.
 */
export function design_challenger_email(
  i18n: InternationalizationAPI,
): SingleColumnFormDesign {
  return {
    type: "single-column",
    fields: [
      {
        id: TalerFormAttributes.CONTACT_EMAIL,
        label: i18n.str`E-Mail`,
        type: "text",
        required: true,
        disabled: true,
      },
    ],
  };
}
